import React, { Component } from 'react';
import { Modal, Form, Button, Input } from 'antd';
import { ReactMultiEmail, isEmail } from 'react-multi-email';
import 'react-multi-email/dist/style.css';
import { useState } from 'react';
const { TextArea } = Input;

export default function ShareDetails({ open, onCancel, title, updateGuideline, loading }) {
    const [emails, setEmails] = useState([]);
    const [focused, setFocused] = useState(false);
    const [form] = Form.useForm();

    const HandleFinish = data => {
        console.log(emails);
        // const { link } = data;
        // updateGuideline(link);
    };
    return (
        <>
            <Modal title={title} open={open} onCancel={onCancel} footer={null} width="50%">
                <div style={{ width: '100%', minHeight: '200px', maxHeight: '500px' }}>
                    <Form form={form} onFinish={HandleFinish} {...{ labelCol: { span: 24 }, wrapperCol: { span: 24 } }}>
                        <Form.Item label="Email Address" name="emails" colon={true}>
                            <ReactMultiEmail
                                placeholder="Input your email"
                                emails={emails}
                                onChange={_emails => {
                                    setEmails(_emails);
                                }}
                                style={{ height: '100px', overflow: 'auto' }}
                                autoFocus={true}
                                onFocus={() => setFocused(true)}
                                onBlur={() => setFocused(false)}
                                getLabel={(email, index, removeEmail) => {
                                    return (
                                        <div data-tag key={index}>
                                            <div data-tag-item>{email}</div>
                                            <span data-tag-handle onClick={() => removeEmail(index)}>
                                                ×
                                            </span>
                                        </div>
                                    );
                                }}
                            />
                        </Form.Item>
                        <Form.Item>
                            <Button block type="primary" htmlType="submit" hidden={true} disabled={loading} loading={loading}>
                                Share
                            </Button>
                        </Form.Item>
                    </Form>
                </div>
            </Modal>
        </>
    );
}
